import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MetricService } from '../service/metric.service';

@Injectable({
    providedIn: 'root'
})
export class MetricValidators
{
    constructor(private metricService: MetricService) { }

    public validateMetricNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.metricService.existsMetricName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
